import React, { useEffect } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import { privacyPolicyList } from './constants';

const PrivacyPolicy = () => {

   useEffect(() => {
      const element = document.getElementById('landingPage')
      element.scrollIntoView({
         block: "start",
         inline: "nearest"
      });
   }, [])

   return (
      <>
         <div id="landingPage" className='faq-header'>
            <Navbar />
         </div >
         <main className='container details-section'>
            <div className='details-wrap pb-5'>
               <h2>
                  Privacy Policy
               </h2>
               <p>
                  Enjoyfresh software solutions Pvt Ltd, its affiliates and subsidiary entities
                  (Collectively, referred to as “EnjoyFresh”), respects your right for privacy, and wishes
                  to protect your Personal Information by devising and implementing organisation-wide
                  measures and standard and policies to protect Personal Information to the maximum
                  extent reasonably practicable and as per the applicable Laws of India.
               </p>
               <p>
                  This Privacy policy shall form part and parcel of Terms of Use, and you may not use,
                  access, browse, or download the Platform or its Application, if case you do not intend
                  to share your Personal Information with us.
               </p>
               <p>
                  This Privacy Policy applies to the personal information, we obtain through
                  EnjoyFresh Website, Application, calls, social media pages (“Online Mode”), by
                  sales, marketing and partner/ supplier engagement ways (“offline Mode”) and through
                  third party sources including ad networks and similar modes (collectively referred to
                  as “Modes”).
               </p>
               <p>
                  This Privacy Policy describes the types of personal information we obtain through the
                  Modes, how we may use that personal information, with whom we may share it, and
                  how you may exercise your rights regarding our processing of the information. The
                  Privacy Policy also describes the measures we take to safeguard the personal
                  information we obtain and how you can contact us about our privacy practices.
               </p>

               {
                  privacyPolicyList.map((privacyPolicy) => {
                     return <div key={privacyPolicy.no}>
                        <h6>{privacyPolicy.question}</h6>
                        <p>{privacyPolicy.answer}</p>
                        {
                           privacyPolicy.list && privacyPolicy.list.length > 0 ? (
                              <ul>
                                 {privacyPolicy.list.map((privacyPolicyListItem, privacyPolicyListItemIndex) => {
                                    return <li key={privacyPolicyListItemIndex}>{privacyPolicyListItem}</li>
                                 })}
                              </ul>
                           ) : ""
                        }
                        {privacyPolicy.answer2 ? <p>{privacyPolicy.answer2}</p> : ""}
                     </div>
                  })
               }
            </div>
         </main>
         <Footer />
      </>
   )
};

export default PrivacyPolicy;
